export const DO_NOT_SELL_PERSONAL_INFO_LINK =
  'https://privacyportal.onetrust.com/webform/ec73b9a1-eecd-48d1-a789-fa7761e54a29/cf3dfa36-1b53-4ec9-8dfc-e84988613fa1';
export const MY_MARKETING_PREFERENCES_LINK =
  'https://privacyportal.onetrust.com/ui/#/preferences/multipage/login/60104e41-6ba2-4141-9154-90f8532cbdb9';
export const FOOTER_BUTTONS_LIST = [
  {
    title: 'FOOTER_PRODUCT',
    icon: 'CatIconSearch'
  },
  {
    title: 'FOOTER_SUPPORT',
    icon: 'CatIconHelp'
  },
  {
    title: 'HEADER_MY_ACCOUNT',
    icon: 'CatIconPerson'
  },
  {
    title: 'Footer_CatSocial',
    icon: 'CatIconPeople'
  },
  {
    title: 'LC_LANGUAGE_CURRENCY',
    icon: 'CatIconLanguage'
  },
  {
    title: 'CAT_SITES_WAFFLE',
    icon: 'CatIconGrid'
  }
];

export const CMC_ESPOT_PCC_FOOTER_PHU_THAI = 'CMC_ESPOT_PCC_FOOTER_PHU_THAI';
export const CMC_ESPOT_PCC_FOOTER_LOGO = 'CMC_ESPOT_PCC_FOOTER_LOGO';
export const PCC_RELEASE_PHU_THAI_CONTENT_FLAG =
  'pcc-release-phu-thai-content-flag';
